import React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";

import css from "./ProductGroupsUpdateProductGroupModal.module.css";
import { toast } from "react-toastify";
import { productGroupService } from "../../../../services/settings-services";
import { productGroupsActions } from "../../../../store/slices/settings-slices";
import { getConfig } from "../../../../config";

const ProductGroupsUpdateProductGroupModal = ({
  setIsOpenUpdate,
  productGroup,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { cityCode } = getConfig();
  const {
    id,
    name: { en, ru, ge, ar },
  } = productGroup;

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ defaultValues: { en: en, ru: ru, ge: ge, ar: ar } });

  const submitHandler = async (data) => {
    try {
      await productGroupService.updateById(id, { name: data });
      dispatch(productGroupsActions.changeTrigger());
      toast.success("khgfgdfyg");
      setIsOpenUpdate(false);
    } catch (error) {
      console.error("Error updating group:", error);
      toast.error(t("modal-toast-creating-error"));
    }
  };

  const closeModal = () => {
    setIsOpenUpdate(false);
  };

  return (
    <section className={css.modalOverlay}>
      <div className={css.modal}>
        <button className={css.closeButton} onClick={closeModal}>
          &times;
        </button>
        <h2 className={css.title}>
          {t("modal-product-groups-update-product-group")}
        </h2>

        <form onSubmit={handleSubmit(submitHandler)}>
          <div className={css.inputGroup}>
            <label htmlFor="en">
              {t("modal-name-input-new-category")}(English)
            </label>
            <input
              type="text"
              id="en"
              {...register("en", {
                required: t(
                  "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
                ),
              })}
              className={errors.en ? css.inputError : ""}
            />
            {errors.en && <p className={css.error}>{errors.en.message}</p>}
          </div>

          <div className={css.inputGroup}>
            <label htmlFor="ru">
              {t("modal-name-input-new-category")}(Русский)
            </label>
            <input
              type="text"
              id="ru"
              {...register("ru", {
                required: t(
                  "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
                ),
              })}
              className={errors.ru ? css.inputError : ""}
            />
            {errors.ru && <p className={css.error}>{errors.ru.message}</p>}
          </div>

          {cityCode === "UAE" ? (
            <>
              <div className={css.inputGroup}>
                <label htmlFor="ar">
                  {t("modal-name-input-new-category")}(العربية)
                </label>
                <input
                  type="text"
                  id="ar"
                  {...register("ar", {
                    required: t(
                      "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
                    ),
                  })}
                  className={errors.ar ? css.inputError : ""}
                />
                {errors.ar && <p className={css.error}>{errors.ar.message}</p>}
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className={css.inputGroup}>
                <label htmlFor="ge">
                  {t("modal-name-input-new-category")}(ქართული)
                </label>
                <input
                  type="text"
                  id="ge"
                  {...register("ge", {
                    required: t(
                      "This field is required / Это поле обязательно / ეს ველი აუცილებელია"
                    ),
                  })}
                  className={errors.ge ? css.inputError : ""}
                />
                {errors.ge && <p className={css.error}>{errors.ge.message}</p>}
              </div>
            </>
          )}

          <div className={css.buttonGroup}>
            <button
              type="button"
              className={css.cancelButton}
              onClick={closeModal}
            >
              cancel
            </button>

            <button type="submit" className={css.okButton}>
              save
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export { ProductGroupsUpdateProductGroupModal };
